import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgInformationCircle32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11m0-15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgInformationCircle32);
export default Memo;